import { CONFIG } from '@h2h/shared';
import { ArrowUp } from '../../components/ui/icons';
import { tierShort } from '../../lib/format';
import { ListCard } from './shared';

// ── Step 5 · Climb the divisions ──────────────────────────────────────────────
type LadderBar = { tier: number; h: number; you?: boolean; gold?: boolean };

const CLIMB_LADDER: LadderBar[] = [
  { tier: 0, h: 18 },
  { tier: 1, h: 28 },
  { tier: 2, h: 40, gold: true },
  { tier: 3, h: 56, you: true },
  { tier: 4, h: 70 },
  { tier: 5, h: 86 }
];

export function ClimbCard() {
  return (
    <ListCard>
      <div className="mb-[16px] flex items-center justify-between px-[3px] pt-[2px]">
        <span className="text-[11px] font-extrabold uppercase tracking-eyebrow text-ink2">
          Tier ladder
        </span>
        <span className="inline-flex items-center gap-[5px] text-[12px] font-extrabold text-accent-ink">
          <ArrowUp width={13} height={13} strokeWidth={3} />
          Moved up 1
        </span>
      </div>

      <div className="flex items-end justify-between gap-[6px] px-[2px]">
        {CLIMB_LADDER.map(({ tier, h, you, gold }) => (
          <div key={tier} className="relative flex-1 text-center">
            {you && (
              <span className="absolute -top-[17px] left-0 right-0 text-[11px] font-extrabold text-accent-ink">
                YOU
              </span>
            )}
            <div
              style={{ height: h }}
              className={
                you
                  ? 'rounded-[7px] border-[1.5px] border-accent bg-gradient-to-b from-[#E6ECF5] to-[#9FB2CC] shadow-[0_0_22px_rgba(36,197,106,0.4)]'
                  : gold
                    ? 'rounded-[6px] bg-gradient-to-b from-gold-top to-gold-bottom opacity-50'
                    : 'rounded-[5px] bg-fill2'
              }
            />
            <div
              className={
                you
                  ? 'mt-[6px] text-[9px] font-extrabold text-[#3C4C66]'
                  : tier === 0
                    ? 'mt-[6px] text-[9px] font-bold text-ink4'
                    : 'mt-[6px] text-[9px] font-bold text-ink3'
              }
            >
              {tierShort(tier)}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-5 flex gap-[9px]">
        <div className="flex flex-1 items-center gap-[7px] rounded-[12px] bg-accent/10 px-[11px] py-[9px]">
          <ArrowUp width={13} height={13} strokeWidth={3} className="text-accent-ink" />
          <span className="text-[11px] font-bold text-accent-ink">Top {CONFIG.PROMOTE_COUNT} promote</span>
        </div>
        <div className="flex flex-1 items-center gap-[7px] rounded-[12px] bg-danger/10 px-[11px] py-[9px]">
          <DropArrow />
          <span className="text-[11px] font-bold text-danger">Bottom {CONFIG.RELEGATE_COUNT} drop</span>
        </div>
      </div>
    </ListCard>
  );
}

function DropArrow() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M17 10l-5 5-5-5"
        stroke="#D2544F"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
